import { useQuery, keepPreviousData } from '@tanstack/react-query';
import * as completenessApi from '../completeness.api';
import type { ProductsQuery } from '../completeness.api';

export function useProducts(query: ProductsQuery) {
  return useQuery({
    queryKey: ['completeness', 'products', query],
    queryFn: () => completenessApi.getProducts(query),
    placeholderData: keepPreviousData,
  });
}

export function useProductDetail(clientId: string, productId: string) {
  return useQuery({
    queryKey: ['completeness', 'product', clientId, productId],
    queryFn: () => completenessApi.getProductDetail(clientId, productId),
    enabled: !!clientId && !!productId,
  });
}

export function useClientDetail(clientId: string) {
  return useQuery({
    queryKey: ['completeness', 'client', clientId],
    queryFn: () => completenessApi.getClientDetail(clientId),
    enabled: !!clientId,
  });
}

export function useClientDashboard(
  clientId: string,
  params?: { brandId?: string; categoryId?: string },
) {
  return useQuery({
    queryKey: ['completeness', 'client', clientId, 'dashboard', params],
    queryFn: () => completenessApi.getClientDashboard(clientId, params),
    enabled: !!clientId,
  });
}

export function useClientBrands(clientId: string) {
  return useQuery({
    queryKey: ['completeness', 'client', clientId, 'brands'],
    queryFn: () => completenessApi.getClientBrands(clientId),
    enabled: !!clientId,
  });
}
